import { Dispatch } from 'redux';
import { catalogAxiosInstance, request } from './base';
import { EnderecoResponse, BancosResponse } from 'common/genericTypes';

export const GETEndereco = async (dispatch: Dispatch, cep: string, stackRequest: boolean = false) => {
  return await request(
    () => catalogAxiosInstance.get<EnderecoResponse>(`api/v1/ceps/${cep}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETBancos = async (dispatch: Dispatch, stackRequest: boolean = false) => {
  return await request(
    () => catalogAxiosInstance.get<BancosResponse>(`api/v1/bancos`),
    dispatch,
    undefined,
    stackRequest
  );
};
